import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'LivePhotoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-live-photo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.9 20.11l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19.04 17.61l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20.77 14l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20.77 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19.04 6.39l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.9 3.89l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.1 3.89l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4.96 6.39l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.23 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.23 14l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4.96 17.61l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.1 20.11l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 21l0 .01"
    }, null), _createTextVNode(" ")]);
  }
};